import { useEffect } from 'react';

// Context
import { useGlobalState } from '@wearetla/tla-essentials-tools/utilities/global-state';

// Services
import siteServices from '/services/site';

const getCityVenues = () => {
	return siteServices.getCityVenues();
};

const getEventCategories = () => {
	return siteServices.getEventCategories();
};

export const GlobalStateController = () => {
	const { locations, eventCategories, setData } = useGlobalState();
	
	// CSR fallback.
	useEffect(() => {
		if (!locations) {
			getCityVenues()
				.then((payload) => {
					setData('locations', payload.cities);
					setData('venues', payload.venues);
				})
				.catch(() => {});
		}
	}, [locations]);

	useEffect(() => {
		if (!eventCategories) {
			getEventCategories()
				.then((eventCategories) => {
					setData('eventCategories', eventCategories);
				})
				.catch(() => {});
		}
	}, [eventCategories]);

	return null;
};

GlobalStateController.getServerProps = () => {
	return new Promise((resolve) => {
		Promise.all([
      getCityVenues(),
      getEventCategories(),
    ])
			.then(([
        cityVenues,
        eventCategories,
      ]) => {
				resolve({
					locations: cityVenues.cities,
					venues: cityVenues.venues,
          eventCategories,
				});
			})
			.catch((e) => {
				console.error('Initial props error: ', e);
				resolve({});
			});
	});
};
